var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.93V1.6409C0 1.62314 0.0266314 1.45492 0.0798941 1.13623L9.07464 8.83137L0.106525 17.4599C0.0496289 17.2873 0.0138596 17.1085 0 16.9273V16.93ZM1.19841 0.080298C1.34195 0.0234786 1.4955 -0.00369844 1.64981 0.000404003H25.8697C26.0323 0.000981902 26.1938 0.0279644 26.3477 0.080298L17.3264 7.8034L16.128 8.75813L13.7724 10.6956L11.4102 8.7568L10.2118 7.80206L1.19841 0.080298ZM1.22504 18.4959L10.2797 9.81939L13.7817 12.6583L17.2838 9.81939L26.3384 18.4959C26.194 18.5496 26.0411 18.5767 25.887 18.5758H1.64582C1.50056 18.5751 1.35663 18.548 1.22105 18.4959H1.22504ZM18.4689 8.83137L27.4383 1.13623C27.4921 1.29902 27.5191 1.46946 27.5182 1.6409V16.93C27.5153 17.1103 27.4884 17.2894 27.4383 17.4626L18.4689 8.83137Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d09f3c852da0df1ac1656a6e2811bb0b.svg";
export { ForwardRef as ReactComponent };